<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("Create Form") }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <div class="row">
        <div class="col-sm-12">
          <package-Form :id="id" :closemodal="closeModal" />
          <!-- <dynamic-form :id="id" :closemodal="closeModal"></dynamic-form> -->
        </div>
      </div>

      <!-- data table Start here -->
      <!-- <div class="mt-4">
        <app-table :id="tableId" />
      </div> -->
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      <!-- <button
        type="button"
        class="btn btn-primary mr-2"
        data-dismiss="modal"
        @click="submit"
      >
        {{ $t("update") }}
      </button> -->
    </template>
  </app-modal>
</template>

<script>
import PackageForm from "./packagesForm.vue";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { axiosPost } from "../../../../Helpers/AxiosHelper";
import * as actions from "../../../../Config/ApiUrl";
// import ThemeMixin from "../../../../../core/mixins/global/ThemeMixin";

export default {
  components: { PackageForm },
  name: "PackageFormModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    id: Number,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        yes: "no",
      },
      modalId: "demo-add-formbuilderbody-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    this.modalTitle = this.$t("Form Builder");
    this.preloader = true;
  },
  methods: {},
  mounted() {
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
  },
};
</script>
